import { render } from "./SfAccordion.vue?vue&type=template&id=3db9e744&scoped=true&ts=true"
import script from "./SfAccordion.vue?vue&type=script&lang=ts"
export * from "./SfAccordion.vue?vue&type=script&lang=ts"

import "./SfAccordion.vue?vue&type=style&index=0&id=3db9e744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db9e744"]])

export default __exports__